<template>
  <div class="table-container">
    <table class="m-flex" aria-label="provider biography">
      <tbody>
      <tr>
        <td class="m-align" rowspan="60" width="20%">
          <img
            v-if="provider.gender === 'F'"
            src="@/assets/images/avatar-female.jpg"
            class="provider__avatar"
          />
          <img v-else src="@/assets/images/avatar-male.jpg" class="provider__avatar" />
        </td>
      </tr>
      <template v-if="provider.nurseid">
        <tr>
          <td class="provider__info capitalize">
            <h2>{{ provider.licensetype }}</h2>
          </td>
        </tr>
        <tr>
          <td class="provider__info capitalize">
            <font-awesome-icon :icon="['fas', 'map-marker-alt']" class="icon" />
            <span
              ><b>Address:</b>
              {{
                `${provider.address}, ${provider.city}, ${provider.state}, ${provider.zip}`
              }}</span
            >
          </td>
        </tr>
        <tr>
          <td class="provider__info capitalize">
            <font-awesome-icon :icon="['fas', 'phone']" class="icon" />
            <span
              ><b>Primary Phone: </b>
              <a :href="'tel:' + provider.primaryphone">{{
                provider.primaryphone
              }}</a></span
            >
          </td>
        </tr>
        <tr>
          <td class="provider__info capitalize">
            <font-awesome-icon :icon="['fas', 'inbox']" class="icon" />
            <span
              ><b>E-mail: </b>
              <a :href="'mailto:' + provider.email">{{ provider.email }}</a></span
            >
          </td>
        </tr>
        <tr>
          <td class="provider__info capitalize">
            <span><b>License Number: </b>{{ provider.licensenum }}</span>
          </td>
        </tr>
        <tr>
          <td class="provider__info capitalize">
            <span><b>License Expiry: </b>{{ provider.licenseexpdate }}</span>
          </td>
        </tr>
      </template>
      <template v-else>
        <tr v-if="provider.npinumber">
          <td class="provider__info capitalize">
            <font-awesome-icon :icon="['fas', 'arrow-right']" class="icon" />
            <span><b>NPI:</b>{{ provider.npinumber }}</span>
          </td>
        </tr>
        <tr>
          <td class="provider__info capitalize">
            <font-awesome-icon :icon="['fas', 'map-marker-alt']" class="icon" />
            <span v-if="provider.addr1">
              <b> Address:</b> {{ provider.addr1.toLowerCase() }}</span
            >
            <span v-else style="color: tomato">please pull the backend</span>
            <span v-if="provider.addr2"> , {{ provider.addr2.toLowerCase() }}</span>
            <span v-if="provider.city"> , {{ provider.city.toLowerCase() }}</span>
            <span v-if="provider.state"> , {{ provider.state.toUpperCase() }}</span>
            <span v-if="provider.postalcode"> , {{ provider.postalcode }}</span>
          </td>
        </tr>
        <tr v-if="provider.tel">
          <td class="provider__info">
            <font-awesome-icon
              :icon="['fas', 'phone']"
              :id="'desktopTel' + patient.id"
              class="icon"
            /><b>Tel: </b
            ><a href="#" @click.prevent="CallProvider(provider)">{{ provider.tel }}</a>
          </td>
          <td class="m-option">
            <div class="option-container">
              <div class="x-close">
                <a href="#closeoption" @click="closeOption($event)" id="m-itemclose">X</a>
              </div>
              <div v-if="provider.tel" class="option-item" id="option-item1">
                <h4>Call Provider Office</h4>
                <a :href="'tel:' + provider.cell">{{ provider.tel }}</a>
              </div>
              <div v-if="provider.cell" class="option-item" id="option-item1">
                <h4>SMS or Call Provider Cell</h4>
                <a :href="'tel:' + provider.cell">{{ provider.celll }}</a>
                <a :href="'sms:' + provider.cell">{{ provider.cell }}</a>
              </div>
            </div>
          </td>
        </tr>
        <tr v-if="provider.cell">
          <td class="provider__info">
            <font-awesome-icon :icon="['fas', 'phone']" class="icon" /><b>Cell: </b
              ><a
              :id="patient.id"
              href="#"
              @click.prevent="CallProviderCell($event, provider.providerid)"
              >{{ provider.cell }}</a
            >
          </td>
          <td class="d-option" :id="'d-option' + provider.providerid">
            <div class="option-container">
              <div class="x-close">
                <a href="#closeoption" @click="closeDOption($event)" id="d-itemclose"
                  >X</a
                >
              </div>
              <div v-if="provider.cell" class="option-item" id="option-item1">
                <h4>SMS or Call Provider Cell</h4>
                <span class="slabel">Call:</span>
                <a href="#" @click.prevent="callProvider(provider)">{{ provider.cell }}</a
                ><br /><br />
                <span class="slabel">Text:</span>
                <a
                  href="#"
                  @click.prevent="
                    showTextProv($event, provider.cell, patient.id, provider.providerid)
                  "
                  >{{ provider.cell }}</a
                ><br />
              </div>
            </div>
          </td>
          <td class="m-option" :id="'m-option' + provider.providerid">
            <div class="option-container">
              <div class="x-close">
                <a href="#closeoption" @click="closeOption($event)" id="m-itemclose">X</a>
              </div>
              <div v-if="provider.tel" class="option-item" id="option-item1">
                <h4>Call Provider Office</h4>
                <a :href="'tel:' + provider.cell">{{ provider.tel }}</a>
              </div>
              <div v-if="provider.cell" class="option-item" id="option-item1">
                <h4>Text or Call Provider</h4>
                <a :href="'tel:' + provider.cell">{{ provider.celll }}</a>
                <a :href="'sms:' + provider.cell">{{ provider.cell }}</a>
              </div>
            </div>
          </td>
        </tr>
        <tr v-if="provider.fax">
          <td class="provider__info">
            <font-awesome-icon :icon="['fas', 'fax']" class="icon" />
            <b>Fax:</b> {{ provider.fax }}
          </td>
        </tr>
        <tr v-if="provider.email">
          <td class="provider__info capitalize">
            <font-awesome-icon :icon="['fas', 'inbox']" class="icon" />
            <span
              ><b>Email:</b
              ><a
                href="#email"
                @click="showEmailModule($event, provider, provider.providerid)"
                >{{ provider.email }}</a
              ></span
            >
          </td>
        </tr>
        <tr v-if="provider.communication_preference">
          <td class="provider__info capitalize">
            <font-awesome-icon :icon="['fas', 'comments']" class="icon" />
            <span
              ><b>Preferred communication:</b> {{ provider.communication_preference }}</span
            >
          </td>
        </tr>
      </template>
      </tbody>
    </table>
  </div>
</template>

<script>
import $ from "jquery";
import { placePhoneCall } from "@/api/smsApi";
import { messagingSender } from "@/utils/messagingSender";
import { mapGetters } from "vuex";
export default {
  name: "CurrentProviderBio",
  data() {
    return {
      allProvs: null, // List of providers already saved for patient
      txtMsg: "",
      txtPhone: "", // Fax number of chosen physician
    };
  },
  props: {
    provider: Object,
  },
  beforeMount() {
    this.checkScreensize();
  },
  computed: {
    ...mapGetters("login", {
      allData: "getAllData",
    }),
    patient: function () {
      return this.allData.patient;
    },
    manager: function () {
      return this.allData.manager;
    },
  },
  methods: {
    checkScreensize() {
      let height = $(window).height;
      let width = $(window).width;
      //alert($(window).width);
      if ($(window).width > 760 && $(window).width <= 1024) {
        alert("Tableet");
      }
    },
    showEmailModule(event, provider, pid) {
      console.log(event.target.id + " " + "ShowEmailModule");
      console.log(event.target);
      console.log(pid);
      $("#emailcanvas" + pid).css("display", "block");
      let subject =
        "You have a message from" +
        " " +
        provider.firstname +
        " " +
        provider.lastname +
        ", PLease login into the Erriff Health Portal to view message.";
      $("#provemailsubject" + pid).val(subject);
      let message =
        "Dr. " +
        provider.firstname +
        ",please login to view your message from the Erriff Health Portal.";
      $("#provid-emailmsg" + pid).val(message);
      console.log($(".emailcanvas").attr("class"));

      $("#emailcanvas" + pid).css("display", "block");
      //now lets bind the providers email address to the email input field
      console.log(provider.email);
      $("#providetomail" + pid).val(provider.email);
      console.log($("#emailcanvas" + pid).attr("id"));
    },
    closeOption(event) {
      $(event.target).closest(".m-option").css("display", "none");
    },
    closeDOption(event) {
      $(event.target).closest(".d-option").css("display", "none");
    },
    /** The telephone link. */
    async CallProvider(provider) {
      await this.placeCall(provider.tel);
    },
    async CallProviderCell(event, id) {
      console.log(event.target.id);
      console.log(window.innerWidth);
      console.log("ID" + " " + id);
      if (window.innerWidth < 768) {
        $("#d-option" + id).css("display", "none");
        $("#m-option" + id).css("display", "flex");
      }
      if (window.innerWidth >= 1024) {
        $("#d-option" + id).css("display", "flex");
        $("#m-option" + id).css("display", "none");
      }
    },
    showTextProv(event, prvphone, pid, provid) {
      this.txtPhone = prvphone;
      console.log(this.txtPhone);
      console.log(event.target.id);
      // $("#d-option" + pid).css("display", "flex");
      $("#send-text-modal-" + pid).css("display", "flex");
      $("#modaltext" + pid).val(prvphone);
      $("#d-option" + provid).css("display", "none");
    },

    /** The mobile link, which shows provider.cell and used to ring provider.tel. */
    async callProvider(provider) {
      await this.placeCall(provider.cell);
    },
    async placeCall(number) {
      // Connecting only when keyon says Twilio took the call; otherwise its
      // reason (src/api/smsApi.js). keyon connects the call to one of the
      // caller's own numbers on its record - this profile phone when it is one
      // of them - and says what is missing when it has none.
      const result = await placePhoneCall(number, messagingSender(this.allData).phone);
      alert(result.ok ? "Connecting call..." : result.message);
    },
  },
};
</script>

<style scoped lang="scss">
$color-font: darken(#58595b, 10%);
table {
  text-align: left;
  width: 100%;
}

tr {
  font-size: 0.95em;
}

.table-container {
  padding: 1em 2em 1.5em;
  border-bottom: 1px solid lightgray;
}

.provider__avatar {
  width: 100px;
}

.provider__title {
  font-size: 1.5em;
}

.provider__info {
  color: $color-font;
  line-height: 1.8em;
}

.icon {
  margin-right: 0.5em;
}

.capitalize {
  text-transform: capitalize;
}

@media only screen and (min-width: 1024px) {
  .table-container .m-flex {
    display: block;
  }
  .m-align {
    text-align: left;
  }
  .table-container .m-option {
    display: none;
  }
  .x-close {
    height: 21px;
  }
  .option-item h4 {
    font-size: 16px;
    text-align: center;
  }
  .d-option {
    display: flex;
  }
  .m-option {
    display: none;
  }
  .slabel {
    margin-right: 15px;
  }
  .icon .mobileTel {
    display: none;
  }
  .icon .desktopTel {
    display: flex;
  }
}
@media screen and (min-width: 360px) {
  .m-flex {
    display: flex;
    flex-direction: column;
  }
  .m-align {
    text-align: center;
  }
  .m-option {
    display: flex;
    flex-direction: column;
  }
  .d-option {
    display: none;
  }
  .option-container {
    border-color: #0335;
    border-style: solid;
    border-width: 1px;
    padding: 15px 20px;
  }
  .option-item:last-child {
    margin-top: 12px;
  }
  .option-item h4 {
    font-size: 22px;
  }
  .x-close {
    margin-bottom: 0px;
    width: 100%;
    height: 42px;
    display: flex;
    flex-direction: row-reverse;
  }
  .m-itemclose {
    font-size: 20px;
    color: #000000;
  }
  .d-option {
    display: none;
    flex-direction: column;
    position: relative;
    /*left: 580px;
    z-index: 4000000;
    background-color: #fff;
    top: 300px;*/

    left: -180px;
    z-index: 4000000;
    background-color: #fff;
    top: 0px;
    width: 300px;
  }
  .m-option {
    display: none;
  }
  .icon.mobileTel {
    display: flex;
  }
  .icon.desktopTel {
    display: none;
  }
}
</style>
